import uuid from "uuid/v4";
import {
  ADD_TO_CART,
  ADJUST_CART_FOR_CHECKOUT,
  DECREMENT_QTY,
  REMOVE_FROM_CART,
  REMOVE_ALL_FROM_CART,
  SAVE_CART
} from "../actions/cartActions";

const initState = [];
const saveCart = (cart) => {
  var body = "{cart:'"+JSON.stringify(cart)+"',IDRef:"+localStorage.getItem("IDDetCliRef")+"}";
    //console.log(credentials);
    //console.log(body);

    var endpoint = global.endpoint + "/pegaso/updateCart";
    fetch(endpoint, {
        method: "POST",
        headers: new Headers({"Content-Type": "application/x-www-form-urlencoded",}),   
        body: body,  
        withCredentials: false,
    })
        .then((res) => res.json())
        .then(
          (result) => {
             
          }
      )
}
const cartReducer = (state = initState, action) => {
  var cartItems = state,
    product = action.payload;
  //console.log(action.type)
 
  var _sper = sessionStorage.getItem('personal');
  if (_sper === 'undefined') _sper = null;
  const personal = _sper ? JSON.parse(_sper) : {};

  switch (action.type) {
    case SAVE_CART:
      cartItems = product
      break;
    case ADJUST_CART_FOR_CHECKOUT:
      //console.log(product);
      cartItems =  cartItems.map(item =>
        
          //item.cartItemId === product.cartItemId ? console.log(product) : console.log(item)
          item.cartItemId === product.cartItemId ? product : item
        
      );
      saveCart(cartItems)
      break;
    case ADD_TO_CART:
      // for non variant products
      if (product.variation === undefined) {
        const cartItem = cartItems.filter(item => item.id === product.id)[0];
        if (cartItem === undefined) {
          cartItems = [
            ...cartItems,
            {
              ...product,
              quantity: product.quantity ? product.quantity : 1,
              cartItemId: uuid(),
              sco1:personal && personal.TipLis == 4? personal.S1 : 0,
              sco2: personal && personal.TipLis == 4? personal.S2 : 0
            }
          ];
        } else {
          cartItems = cartItems.map(item =>
            item.cartItemId === cartItem.cartItemId
              ? {
                  ...item,
                  quantity: product.quantity
                    ? parseInt(item.quantity) + parseInt(product.quantity)
                    : parseInt(item.quantity) + 1,
                    sco1:personal && personal.TipLis == 4? personal.S1 : 0,
                    sco2: personal && personal.TipLis == 4? personal.S2 : 0
                }
              : item
          );
        }
        // for variant products
      } else {
        const cartItem = cartItems.filter(
          item =>
            item.id === product.id &&
            product.selectedProductColor &&
              product.selectedProductColor === item.selectedProductColor &&
            product.selectedProductSize &&
              product.selectedProductSize === item.selectedProductSize &&
            (product.cartItemId ? product.cartItemId === item.cartItemId : true)
        )[0];
        const variation = product.variation.filter(
          item =>
            product.selectedProductColor &&
              product.selectedProductColor === item.color
        )[0];
        if (cartItem === undefined) {
          
          cartItems = [
            ...cartItems,
            {
              ...product,
              variation:[variation],
              quantity: product.quantity ? product.quantity : 1,
              cartItemId: uuid(),
              sco1:personal && personal.TipLis == 4? personal.S1 : 0,
              sco2: personal && personal.TipLis == 4? personal.S2 : 0
            }
          ];
        } else if (
          cartItem !== undefined &&
          (cartItem.selectedProductColor !== product.selectedProductColor ||
            cartItem.selectedProductSize !== product.selectedProductSize)
        ) {
          cartItems = [
            ...cartItems,
            {
              ...product,
              variation:[variation],
              quantity: product.quantity ? product.quantity : 1,
              cartItemId: uuid(),
              sco1:personal && personal.TipLis == 4? personal.S1 : 0,
              sco2: personal && personal.TipLis == 4? personal.S2 : 0
            }
          ];
        } else {
          cartItems = cartItems.map(item =>
            item.cartItemId === cartItem.cartItemId
              ? {
                  ...item,
                  quantity: product.quantity
                    ? parseInt(item.quantity) + parseInt(product.quantity)
                    : parseInt(item.quantity) + 1,
                  variation:[variation],
                  selectedProductColor: product.selectedProductColor,
                  selectedProductSize: product.selectedProductSize,
                  sco1:personal && personal.TipLis == 4? personal.S1 : 0,
                  sco2: personal && personal.TipLis == 4? personal.S2 : 0
                }
              : item
          );
        }
      }
      saveCart(cartItems)
      break;
    case DECREMENT_QTY:
      if (product.quantity === 1) {
        const remainingItems = (cartItems, product) =>
          cartItems.filter(
            cartItem => cartItem.cartItemId !== product.cartItemId
          );
        cartItems = remainingItems(cartItems, product);
      } else {
        cartItems = cartItems.map(item =>
          item.cartItemId === product.cartItemId
            ? { ...item, quantity: item.quantity - 1 }
            : item
        );
      }
      saveCart(cartItems)
      break;
    case REMOVE_FROM_CART:
      const remainingItems = (cartItems, product) =>
        cartItems.filter(
          cartItem => cartItem.cartItemId !== product.cartItemId
        );
      cartItems = remainingItems(cartItems, product);
      saveCart(cartItems)
      break;
    case REMOVE_ALL_FROM_CART:
      cartItems = cartItems.filter(item => {
        return false;
      });
      saveCart(cartItems)
      break;
    default:
      cartItems = state;
  }
  
  return cartItems
};

export default cartReducer;
